<script lang="ts" setup>
import { computed } from 'vue';
import { ApiError } from '@/helpers/api-error';

interface Props {
  error: unknown;
  dismissable?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  dismissable: true,
});

const emit = defineEmits<{
  dismiss: [];
}>();

const message = computed(() => {
  if (!props.error) return '';
  if (props.error instanceof ApiError) return props.error.userMessage;
  if (props.error instanceof Error) return props.error.message;
  if (typeof props.error === 'string') return props.error;
  return 'Something went wrong';
});
</script>

<template>
  <div v-if="error" class="alert alert-danger d-flex align-items-start" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2 mt-1 flex-shrink-0"></i>
    <div class="flex-grow-1" style="white-space: pre-line;">{{ message }}</div>
    <button
      v-if="dismissable"
      type="button"
      class="btn-close ms-2"
      aria-label="Close"
      @click="emit('dismiss')"
    ></button>
  </div>
</template>
